"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.reduce.js");

var _react = _interopRequireDefault(require("react"));

const _excluded = ["children", "options"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Defaults


const TOTAL_TIME = 10000;
const OFFSET_TOP = 0;
const DEFAULT_DUPLICATES = 2;
const FPS = 1000 / 60; // Base style for slide

const slideStyle = {
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "middle"
};
/**
 * Get slides height and width
 * @param {HTMLElement} slider Slider element
 * @param {number} initialLength Original number of slice (before duplicating)
 */

const getSlidesData = function getSlidesData(slider) {
  let initialLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!slider) return [];
  const slides = [].slice.call(slider.children);
  return slides.slice(0, initialLength).map(slide => {
    return {
      width: slide.offsetWidth,
      height: slide.offsetHeight
    };
  });
};

const Slider = _ref => {
  let {
    children,
    options = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const totalTime = options.totalTime || TOTAL_TIME;
  const offsetTop = options.offsetTop || OFFSET_TOP;
  const fps = options.fps || FPS; // Slider

  const ref = _react.default.useRef(); // With / Height


  const [sliderWidth, setSliderWidth] = _react.default.useState("auto");

  const [sliderHeight, setSliderHeight] = _react.default.useState("auto"); // Duplicated slides


  const [duplicates, setDuplicates] = _react.default.useState(1); // Animation


  const [translate, setTranslate] = _react.default.useState(0);

  const currentTime = _react.default.useRef();

  const frameId = _react.default.useRef();

  const lastProgressStep = _react.default.useRef();

  const lastFrameTimestamp = _react.default.useRef(); // Throttle
  // Save progress for play / pause


  _react.default.useEffect(() => {
    lastProgressStep.current = translate;
  }, [translate]);
  /**
   * Set progress based on time enlapsed
   * Reset when reaches the end
   * @param {number} timestamp Timestamp from requestAnimationFrame
   */


  const animateSlider = _react.default.useCallback(timestamp => {
    if (!currentTime.current) currentTime.current = timestamp; // Throttle

    if (!lastFrameTimestamp.current) lastFrameTimestamp.current = timestamp;
    const timeEnlapsedSinceLastFrame = timestamp - lastFrameTimestamp.current; // Throttle

    if (timeEnlapsedSinceLastFrame > fps) {
      const progress = Math.min((timestamp - currentTime.current) / TOTAL_TIME, 1);
      setTranslate(progress); // Throttle

      lastFrameTimestamp.current = null;

      if (progress < 1) {
        frameId.current = window.requestAnimationFrame(animateSlider);
      } else {
        currentTime.current = null;
        setTranslate(0);
        frameId.current = window.requestAnimationFrame(animateSlider);
      }
    } else {
      frameId.current = window.requestAnimationFrame(animateSlider);
    }
  }, [setTranslate, fps]);
  /**
   * Pause slider animation
   */


  const pause = _react.default.useCallback(() => {
    cancelAnimationFrame(frameId.current);
    frameId.current = null;
  }, []);
  /**
   * Play slider from last step
   */


  const play = _react.default.useCallback(() => {
    if (!frameId.current) {
      const timeEnlapsed = totalTime * lastProgressStep.current;
      frameId.current = window.requestAnimationFrame(timestamp => {
        currentTime.current = timestamp - timeEnlapsed;
        animateSlider(timestamp);
      });
    }
  }, [totalTime]);
  /**
   * Pause when document is hidden
   */


  const handleVisibilityChange = _react.default.useCallback(() => {
    if (document.visibilityState === "hidden") pause();
    if (document.visibilityState === "visible" && isInViewport()) play();
  }, [pause, play]);
  /**
   * Check if slider is in viewport
   */


  const isInViewport = _react.default.useCallback(() => {
    const slider = ref.current;
    const rect = slider.getBoundingClientRect();
    const top = rect.top - offsetTop;
    return top > 0;
  }, [offsetTop]);
  /**
   * Pause when slider leaves viewport
   */


  const handleViewportState = _react.default.useCallback(() => {
    if (!isInViewport()) {
      pause();
    } else {
      play();
    }
  }, [pause, play, isInViewport]);
  /**
   * Duplicate slides to fill screen
   */


  const duplicateSlides = _react.default.useCallback(() => {
    if (sliderWidth < window.innerWidth) {
      const duplicateSize = window.innerWidth / (sliderWidth / 2);
      setDuplicates(parseInt(duplicateSize));
    } else {
      setDuplicates(DEFAULT_DUPLICATES);
    }
  }, [setDuplicates, sliderWidth]);
  /**
   * Set slider height based on slide max height
   */


  const updateSliderHeight = _react.default.useCallback(() => {
    const slider = ref.current;
    const slidesData = getSlidesData(slider, children.length);
    const maxHeight = slidesData.reduce((a, b) => a > b.height ? a : b.height, 0);
    setSliderHeight(maxHeight);
  }, [setSliderHeight, children.length]); // Add slides to have infinite effect


  _react.default.useEffect(() => {
    duplicateSlides();
    window.addEventListener("resize", duplicateSlides);
    return () => window.removeEventListener("resize", duplicateSlides);
  }, [duplicateSlides]);
  /**
   * Set slider height
   */


  _react.default.useEffect(() => {
    updateSliderHeight();
    window.addEventListener("resize", updateSliderHeight);
    return () => window.removeEventListener("resize", updateSliderHeight);
  }, [updateSliderHeight]);
  /**
   * Set slider with and start animation
   */


  _react.default.useEffect(() => {
    const slider = ref.current;
    const slidesData = getSlidesData(slider, children.length);
    const totalWidth = slidesData.reduce((a, b) => a + b.width, 0); // Set slider width

    setSliderWidth(totalWidth); // Fire animation

    frameId.current = window.requestAnimationFrame(animateSlider); // Events

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("scroll", handleViewportState); // Clean Events

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("scroll", handleViewportState);
    };
  }, [animateSlider, handleVisibilityChange, handleViewportState, children.length]); // Slide height


  const height = _react.default.useMemo(() => typeof sliderHeight === 'string' ? sliderHeight : "".concat(sliderHeight, "px"), [sliderHeight]); // Slider total with


  const width = _react.default.useMemo(() => typeof sliderWidth === 'string' ? sliderWidth : "".concat(sliderWidth * duplicates, "px"), [sliderHeight, duplicates]);

  return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    style: {
      width,
      transform: "translateX(-".concat(translate * sliderWidth, "px)")
    }
  }, new Array(duplicates).fill().map((_, i) => children.map((child, key) => {
    const id = "slide-".concat(i, "-").concat(key);

    const style = _objectSpread(_objectSpread({}, slideStyle), {}, {
      height
    });

    return /*#__PURE__*/_react.default.createElement("div", {
      key: id,
      style: style
    }, child);
  }))));
};

var _default = Slider;
exports.default = _default;